import { UseFormReturn } from 'react-hook-form';
import { FormFieldProps, TextInputField } from '@brighte/form-components';
import { BusinessDetailsType, EnterpriseStructure } from '@brighte/validation';
import { Address, AddressWithSameAsCheckbox } from '@components/Address';
import { Text } from '@spark-web/text';
import { useApplicationData } from '../../provider';
import { BUSINESS_DETAILS, LABELS } from '../../utils';

type BusinessDetailsProps = {
  formContext: UseFormReturn<BusinessDetailsType>;
  structure: EnterpriseStructure;
};

function BusinessDetailsFields({ structure, formContext }: Readonly<BusinessDetailsProps>) {
  const { control, setValue, watch } = formContext;
  const businessDetails = useApplicationData('BusinessDetails');

  const {
    BUSINESS_NAME,
    OFFICE_ADDRESS,
    PRINCIPAL_PLACE,
    ACN_NUMBER,
    ASSOCIATION_NUMBER,
    ASSOCIATION_NUMBER_SUB,
    IS_SAME_AS_OFFICE,
  } = LABELS;

  const { BUSINESS_DETAILS_FIELDS_DESCRIPTION } = BUSINESS_DETAILS;

  const sourceAddress = watch('enterprise.registeredAddress');

  return (
    <>
      <Text>{BUSINESS_DETAILS_FIELDS_DESCRIPTION}</Text>
      <TextInputField name="enterprise.legalEntityName" control={control} label={BUSINESS_NAME} />
      <Address<BusinessDetailsType>
        control={control}
        name="enterprise.registeredAddress"
        label={OFFICE_ADDRESS}
        setValue={setValue}
        defaultValue={businessDetails?.enterprise?.registeredAddress}
      />

      {structure === EnterpriseStructure.Company && (
        <>
          <AddressWithSameAsCheckbox
            name="enterprise.principalBusinessAddress"
            sourceAddress={sourceAddress}
            formContext={formContext as FormFieldProps<BusinessDetailsType>}
            fieldLabel={PRINCIPAL_PLACE}
            checkboxLabel={IS_SAME_AS_OFFICE}
            checkboxName="isSame"
          />
          <TextInputField name="enterprise.acnNumber" control={control} label={ACN_NUMBER} />
        </>
      )}

      {structure === EnterpriseStructure.ProprietaryLimitedCompany && (
        <TextInputField name="enterprise.acnNumber" control={control} label={ACN_NUMBER} />
      )}

      {(structure === EnterpriseStructure.IncorporatedAssociation ||
        structure === EnterpriseStructure.UnincorporatedAssociation) && (
        <TextInputField
          name="enterprise.associationNumber"
          control={control}
          label={ASSOCIATION_NUMBER}
          FieldProps={{
            description: ASSOCIATION_NUMBER_SUB,
          }}
        />
      )}
    </>
  );
}

export default BusinessDetailsFields;
